import { coverThumbPath, parseCoverCode } from '@covers/projectCover';
import { API_BASE_URL } from '@/config/serverConfig';

/**
 * Превью обложки с нашего сервера: webp шириной 288 px вместо полной обложки с CDN (сотни килобайт).
 * Нет обложки на CDN — сервер отвечает 404, и <img> уходит в onError. null — кода нет или он не похож на код.
 */
export function getProjectCoverThumbUrl(asta: string | null | undefined): string | null {
  const code = parseCoverCode(asta);
  return code ? `${API_BASE_URL}${coverThumbPath(code)}` : null;
}
